// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/swiper-navigations/swiper-prev-disable.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/swiper-navigations/swiper-next-disable.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/swiper-navigations/swiper-prev.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/swiper-navigations/swiper-next.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/pana.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../img/Rectangle 57.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../img/Rectangle 59.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../img/Rectangle 59.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../img/our-practitioners-section.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../img/faqs-setion-bg-img.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../img/quotes.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  overflow-y: auto;
}

body {
  color: #666666;
  font-size: 14px;
  font-family: 'Poppins', sans-serif;
  font-weight: normal;
}
.font-family-poppins {
  font-family: 'Poppins', sans-serif;
}
.search-bar {
  width: 500px !important;
  height: 45px;
  background-color: #eeeeee !important;
}
.search-icon {
  font-size: 35px;
  color: #666666;
}
/* fisrt-banner starts */

.bannerSection {
  min-height: 40rem;
  background: linear-gradient(360deg, #cdbbe8 9.1%, rgba(232, 241, 255, 0.47) 89.76%);
}
.bannerSection .banner-home {
  max-width: 790px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
.mainTitle {
  line-height: 1.4;
}

.first-banner h1,
p {
  padding-bottom: 20px;
}

.label-bnr {
  font-size: 18px;
  font-family: 'Muli', sans-serif;
  font-weight: 600;
  margin-bottom: 35px;
  text-transform: uppercase;
  color: #1f2b7b;
  display: inline-block;
  position: relative;
  padding-left: 100px;
  letter-spacing: 0.05em;
}
.label-bnr::before {
  position: absolute;
  content: '';
  width: 70px;
  height: 2px;
  background: #1f2b7b;
  top: 0;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
}
.slider__headingtext {
  font-size: 63px;
  font-weight: bold;
}
.slider__content {
  font-size: 18px;
  color: #666666;
}
.creative {
  display: inline-block;
}

/* first banner ends */
form .col-auto {
  display: flex !important;
  justify-content: space-between;
}
input.form-check-input {
  border: 1px solid black;
}

/* services starts */
/* .card-class {
  margin-top: 30px !important;
  display: flex;
  justify-content: center;
  width: 20rem;
}
.card-head {
  font-size: 45px;
  color: #2d2d2d;
  line-height: 50px;
  font-weight: bold;
  padding: 0;
} */
/* services ends */

/* pricing starts */
.pricing-title {
  padding-bottom: 40px;
}
/* pricing ends */

/* heading starts*/
.heading-title h2,
.heading-title h4 {
  color: #fff;
  font-size: 45px;
  line-height: 50px;
  font-weight: bold;
  padding: 0;
  padding-top: 90px;
  /* text-align: center; */
}
.heading-title_h2 {
  font-family: Lato, sans-serif;
  font-size: 45px;
  font-weight: 700;
  line-height: 50px;
  color: #212529 !important;
}
.heading-title p {
  margin: 0px;
  font-weight: normal;
  font-size: 17px;
  line-height: 28px;
  color: #fff;
  padding-top: 10px;
  /* text-align: center; */
  padding-bottom: 40px;
}
/* heading ends*/

/* blog starts */

.latest {
  background: #fff;
  padding-top: 10px;
  padding-left: 0;
  padding-right: 0;
  box-shadow: 0 0 69px rgba(13, 3, 3, 0.06);
  margin-bottom: 55px;
  width: -webkit-max-content;
  width: max-content;
}
/* blog starts */
.blog-col {
  display: flex;
  /* justify-content: center; */
}
/* customer starts */

.customers {
  background: #fff;
  padding-top: 80px;
  padding-bottom: 50px !important;
}
.customer-row {
  display: flex;

  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.customer-carousel {
  position: relative;
}
.customer-carousel-item {
  width: 100%;
  height: 100%;
  perspective: 1000px;
  padding-bottom: 30px;
}
.customer-carousel-cap {
  position: absolute;
}
.profile img {
  border-radius: 50%;
}
.test-box p {
  color: #2d2d2d;
  font-size: 17px;
  line-height: 30px;
  border: #bcbcbb solid 1px;
  padding: 60px 30px;
  border-radius: 10px;
}
/* customer ends */

/* footer starts */

.customer-col {
  display: flex;
  justify-content: center;
}

.read_more {
  color: #fff !important;
  display: inline-block;
  font-size: 16px !important;
  text-decoration: none !important;
  background-size: 200% !important;
  transition: 0.6s !important;
  box-shadow: 0px 7px 21px 0px rgba(173, 17, 17, 0.12) !important;
  background-image: linear-gradient(to left, #caf0ef, #177994, #ee8af8) !important;
  border-radius: 30px !important;
  font-weight: bold !important;
  padding: 10px 30px;
  /* width: 150px !important; */
  /* line-height: 61px !important; */
  /* text-transform: uppercase !important; */
  text-align: center !important;
  /* max-width: 230px !important; */
  /* padding: 10px 20px; */
}
.read_more:hover {
  background-position: right;
  color: #177994 !important;
}

/* Extra small devices (phones, 600px and down) */

/* My code */

.card-practitioner {
  width: 25rem;
  box-shadow: 0px 7px 21px 0px rgba(0, 0, 0, 0.12);
  border: none;
  padding-left: 10px;
  padding-right: 10px;
  transition: 0.5s all;
}

/* .practitioner__list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 20px;
} */

.card__practitioner__text {
  font-size: 18px;
  color: #666666;
}

/* Footer */

.footers {
  display: block;
  position: relative;
  margin-top: 90px;
  padding-top: 90px;
  background: #f5f8ff;
  text-align: center;
  width: 100%;
}

/* .footer-heading_h2::before {
  position: absolute;
  content: '';
  width: 15px;
  height: 15px;
  background: #fdc001;
  background: #177994;
  top: 5px;
  border-radius: 20px;
  left: -20px;
} */
.footer-heading_h2 {
  position: relative;
  /* color: #fff; */
  font-size: 20px;
  font-weight: 500;
  line-height: 23px;
  text-align: left;
}
.menu-footer {
  text-align: left;
  margin-bottom: 15px;
  width: -webkit-max-content;
  width: max-content;
}
.menu-footer li {
  margin: 0px;
  padding: 0px;
  list-style: none;
}
.menu-footer li a {
  /* color: #979793; */

  line-height: 18px;
  padding-bottom: 12px;
  display: block;
  font-size: 16px;
}
.newsL {
  width: 100%;
  height: 51px;
  background: #2d2d2d;
  color: #c9c7c7;
  font-size: 17px;
  font-weight: normal;
  box-shadow: inherit;
  padding: 0 15px;
  border: #fff solid 2px;
  margin-bottom: 20px;
  border-radius: 10px;
}

.subsci_btn {
  font-size: 16px;
  transition: ease-in all 0.5s;
  text-transform: uppercase;
  color: #fff;

  font-weight: normal;
  height: 51px;
  width: 100%;
  display: block;
  border-radius: 10px;
  box-shadow: 0px 7px 21px 0px rgba(0, 0, 0, 0.12);
  background-image: linear-gradient(to left, #caf0ef, #177994, #ee8af8);
}

.subsci_btn_blogs {
  font-size: 16px;
  transition: ease-in all 0.5s;
  text-transform: uppercase;
  color: #fff;
  font-weight: normal;
  line-height: 45px;
  height: 51px;
  width: 100%;
  display: block;
  border-radius: 80px;
  box-shadow: 0px 7px 21px 0px rgba(0, 0, 0, 0.12);
  background-image: linear-gradient(to left, #caf0ef, #177994, #ee8af8);
}

/* copyright section */
.copyright {
  padding-top: 50px;
  padding-bottom: 50px;
}
.social-icon {
  margin: 0px;
  padding: 0px;
  list-style: none;
}

.social-icon li {
  display: inline-block;
  margin: 0 2px;
  padding: 0px;
  list-style: none;
  padding-left: 8px;
  padding-right: 8px;
  margin-bottom: 16px;
}
.social-icon li a {
  display: flex;
  gap: 12px;
}
.socialIcon {
  height: 42px;
  width: 42px;
}
.copyright p {
  /* color: #fff; */
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  padding-top: 35px;
  font-weight: normal;
  margin: 0;
}

.social_icon_style {
  font-size: 17px;
  color: #fff;
  transition: ease-in all 0.5s;
  /* background: #2d2d2d; */
  width: 22px;
  height: 22px;
  line-height: 10px;
  /* border-radius: 50px; */
  text-align: center;
  padding-right: 6px;
}
.social_icon_style_blogs {
  font-size: 25px;
  color: black;
  transition: ease-in all 0.5s;
  /* background: #2d2d2d; */
  width: 45px;
  height: 45px;
  line-height: 10px;
  /* border-radius: 50px; */
  text-align: center;
  padding-right: 6px;
}

.social_icon_style::before {
  content: '\\f041';
}

.footers .linkingSection {
  padding: 50px 0;
  border-top: 1px solid #d1d1d1;
  border-bottom: 1px solid #d1d1d1;
}
.footers .subScribeSection {
  margin-bottom: 50px;
}
.footers .subScribeSection p {
  text-transform: capitalize;
}

.footers .mailInput {
  border: 0;
  background: #e4e9fb;
  border-radius: 25px;
  height: 48px;
  padding-left: 24px;
  max-width: 100%;
  width: 336px;
}

.otherSectionCard .card {
  border: 0;
  background-color: transparent;
  z-index: 2;
}
.otherSectionCard .card img,
.otherSectionCard .card {
  border-radius: 12px;
}
.otherSectionCard .card span {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  font-weight: bold;
  width: 100%;
  text-align: center;
}
.otherSectionCard .card::before {
  content: '';
  background: linear-gradient(180deg, rgba(37, 37, 37, 0) 30%, rgba(0, 0, 0, 0.6) 100%);
  height: 100%;
  width: 100%;
  z-index: 1;
  position: absolute;
  border-radius: 12px;
}

.otherSectionCard .cardParent:hover .hvrContent {
  opacity: 0.9;
}
.cardParent:hover .card span {
  opacity: 0;
}
.hvrContent {
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 9;
  background: #f6eff8;
  width: calc(100% - 20px);
  transform: translateX(-50%);
  height: 100%;
  border-radius: 12px;
  padding: 20px 35px;
  opacity: 0;
  transition: 0.2s ease-out;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.discoverSectionTabs span.active {
  border: 1px solid #7578df;
  padding: 12px 20px;
  border-radius: 23px;
  color: #7578df;
}
.discoverSectionTabs span:hover {
  cursor: pointer;
}

.expertCard .expertImg {
  width: 80px;
  height: 80px;
}

.expertCard hr {
  border: 0;
  background-color: #e7e7e7;
  opacity: 1;
}
.expertCard {
  box-shadow: 0px 0px 8px 0px rgba(105, 145, 210, 0.25);
  border-radius: 16px;
  border: 1px solid transparent;
  transition: 0.4s all;
}
.expertCard:hover {
  border-color: #7578df;
}

.expertCard .profession {
  display: -webkit-box;
  min-height: 61px;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.expertise-main p:last-child {
  min-height: 91px;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  padding-bottom: 0;
  margin-bottom: 20px;
}

.text-truncate-6 {
  -webkit-line-clamp: 6;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* slider css start */
.discoverUsSection .swiperbtn-wrapper {
  bottom: -80px;
}
.swiperbtn-wrapper {
  top: auto;
  bottom: 0;
  right: 50%;
  transform: translate(50%, -50%);
  column-gap: 30px;
}
.swiperbtn-wrapper .swiper-button-prev,
.swiperbtn-wrapper .swiper-button-next {
  width: 49px;
  height: 48px;
}
.swiperbtn-wrapper .swiper-button-prev.swiper-button-disabled::after {
  content: '';
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  width: 48px;
  height: 48px;
}
.swiperbtn-wrapper .swiper-button-next.swiper-button-disabled::after {
  content: '';
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: cover;
  width: 48px;
  height: 48px;
}
.swiperbtn-wrapper .swiper-button-prev::after {
  content: '';
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: cover;
  width: 48px;
  height: 48px;
}
.swiperbtn-wrapper .swiper-button-next::after {
  content: '';
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-size: cover;
  width: 49px;
  height: 48px;
}
.swiper-padding .swiper {
  padding: 10px 20px;
}
/* slider css end */

.joinus .read_mores {
  margin: 0 auto;
  display: block;
  position: relative;
  z-index: 99;
  width: 300px !important;
  color: #fff !important;
  display: inline-block;
  font-size: 16px !important;
  text-decoration: none !important;
  background-size: 200% !important;
  transition: 0.6s !important;
  box-shadow: 0px 7px 21px 0px rgba(173, 17, 17, 0.12) !important;
  background-image: linear-gradient(to left, #caf0ef, #177994, #ee8af8) !important;
  border-radius: 30px !important;
  font-weight: bold !important;
  text-align: center !important;
  padding: 15px 20px;
}
.joinus .read_more:hover {
  background-position: right;
  color: #177994 !important;
}

.fs--1 {
  font-size: 12px !important;
}

.gradent-border {
  border-radius: 5px !important;
  border-image-source: linear-gradient(rgba(0, 51, 102, 0.5), rgba(0, 0, 51, 0.5));
  border-width: 2pt;
  border-image-slice: 1;
  --input-bg-color: #fff;
  border-color: #336cfb !important;
  box-shadow: none;
  color: #1f2022;
  border: 1px solid transparent;
}

.gradent-text {
  background: -webkit-linear-gradient(#4389a2, #5c258d);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.gradent-text::selection {
  color: #fff !important;
  background: gray;
}

.rounded-7 {
  border-radius: 1.3rem !important;
}

.card-shadow {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
}

.btn-grad:hover {
  background-position: right center;
  color: #fff;
  text-decoration: none;
}

.btn-grad {
  background-image: linear-gradient(to right, #5c258d 0%, #4389a2 51%, #5c258d 100%) !important;
  transition: 0.5s;
  background-size: 200% auto;
  box-shadow: 0 0 20px #eee;
  color: #fff;
}

.login-btn-grad {
  background: #5c258d;
  background-size: 200% auto;
  color: #fff;
}

.text-purple {
  color: #5c258d;
}

.avatar-2 {
  width: 60px;
  height: 60px;
  object-fit: contain;
  aspect-ratio: 1;
}

@media (min-width: 992px) {
  .no-record {
    min-height: 320px;
  }

  .min-h-500 {
    min-height: 500px;
  }
}

.text-gray {
  color: gray;
  font-weight: 500;
}

.scrollbar-thin {
  scrollbar-width: thin;
}

.scrollbar-none {
  scrollbar-width: none;
}

.life-style-list {
  list-style-type: disc;
}

ul.life-style-list li {
  font-size: 16px;
  font-weight: 500;
  /* color: #000; */
  margin-bottom: 5px;
  text-align: left;
}

ul.life-style-list.small li {
  font-size: 16px;
  font-weight: 500;
  color: #000;
  margin-bottom: 2px;
  text-align: left;
  margin-left: 30px;
}

.list-image {
  max-width: 100%;
  max-height: 260px;
  width: auto;
  margin: auto;
}

.ls-1 {
  letter-spacing: 1px;
}

.btn-pink {
  color: #fff;
  background-color: #d63484;
  border-color: #d63484;
}

.disabled,
.ant-btn:disabled,
.btn:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}

.background-dashboard-card {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: 275px 140px;
  background-repeat: no-repeat;
  background-position-x: right;
  background-position-y: bottom;
}

.object-fit-contain {
  object-fit: contain !important;
}

.nav-shadow {
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
}

.auth-page-btn {
  max-width: 450px;
  width: 100%;
  text-align: left;
  padding: 10px;
  color: #1f2022;
}

.auth-bg-2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-position: 100%;
  background-size: cover;
  opacity: 0.8;
}

.auth-bg-3 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position-x: 0px;
  opacity: 0.8;
}

.auth-bg-4 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position-x: 0px;
  opacity: 0.8;
}

.text-black {
  color: #000 !important;
}

.bg-white-opacity {
  background-color: rgba(255, 255, 255, 0.75);
}

.letter-spacing-1 {
  letter-spacing: 1px;
}

#root #search .ant-select-auto-complete .ant-select-selector {
  border: 1px solid #bd80c2;
  border-radius: 30px;
  background-image: linear-gradient(white, white),
    linear-gradient(to right, rgba(0, 51, 102, 0.5), rgba(0, 0, 51, 0.5));
  background-origin: border-box;
  background-clip: content-box, border-box;
  background-color: #ffffff;
}
#root .ant-select-auto-complete .ant-select-selector:not(textarea) {
  height: 54px;
  box-shadow: 0px 0px 12px 8px rgba(212, 196, 236, 0.6);
}
#root .no-box-shadow > div {
  height: 40px !important;
  box-shadow: none !important;
}
#root .ant-select-auto-complete {
  height: 100%;
  border-radius: 30px !important;
}
.anticon.anticon-search svg {
  color: #bd80c2;
}

.subImg {
  margin-top: 15px;
  position: relative;
  bottom: -45px;
}
.subImg img {
  border-radius: 12px;
  box-shadow: 0px 5px 10px 0px rgba(113, 113, 113, 0.25);
}

.bannerIcon1 {
  top: 23%;
  left: 9%;
}

.bannerIcon2 {
  top: 43%;
  left: 15%;
}

.bannerIcon3 {
  top: 23%;
  right: 9%;
}

.bannerIcon4 {
  top: 43%;
  right: 15%;
}

.discoverExpertSection {
  padding-top: 10rem !important;
  padding-bottom: 7.5rem !important;
}
.discoverCardSection .card {
  box-shadow: 0px 0px 8px 0px rgba(105, 145, 210, 0.25);
}

.ourPractitionersSection {
  background: linear-gradient(
      90deg,
      rgba(242, 198, 222, 0.12) 0%,
      rgba(219, 205, 240, 0.3) 38.5%,
      #dbcdf0 55.5%
    ),
    url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-size: contain;
  min-height: 603px;
  /* background: linear-gradient(90deg, rgba(242, 198, 222, 0.12) 0%, rgba(219, 205, 240, 0.3) 38.5%, #DBCDF0 55.5%); */
}

.faqs-section {
  background: linear-gradient(
      90deg,
      rgba(242, 198, 222, 0.12) 0%,
      rgba(219, 205, 240, 0.3) 22.14%,
      #dbcdf0 43.18%
    ),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-size: contain;
  min-height: 722px;
}

.quoteImg {
  position: absolute;
  top: 0;
  left: 0;
}
.sliderCard {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: top left;
  background-size: auto;
}
.sliderCard .detail {
  position: relative;
  top: -12px;
  right: -54px;
  z-index: 1;
}

.sliderCard .detail img {
  height: 58px;
  width: 58px;
}

.practitioner__list .ant-collapse > .ant-collapse-item > .ant-collapse-header {
  font-size: 20px;
  border-radius: 12px !important;
  padding: 20px;
  flex-direction: row-reverse;
  align-items: center;
}

.practitioner__list.faq_list .ant-collapse > .ant-collapse-item > .ant-collapse-header {
  padding-left: 0;
}

.practitioner__list .ant-collapse {
  background-color: transparent;
  border: 0;
}

.ant-collapse-item {
  margin-bottom: 24px;
}

.practitioner__list.faq_list .ant-collapse-item {
  margin-bottom: 0;
}

.practitioner__list
  .ant-collapse
  > .ant-collapse-item.ant-collapse-item-active
  > .ant-collapse-header {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.practitioner__list .ant-collapse .ant-collapse-content {
  border-top: 0;
  background-color: transparent;
}

.practitioner__list .ant-collapse .ant-collapse-content > .ant-collapse-content-box {
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
  padding-top: 0;
}

.practitioner__list.faq_list .ant-collapse .ant-collapse-content > .ant-collapse-content-box {
  padding-left: 0;
}

.practitioner__list .ant-collapse > .ant-collapse-item {
  border-bottom: 0;
}

.readyGrowImg {
  z-index: 1;
}

.readyGrowImg img {
  border-radius: 12px;
  box-shadow: 0px 0px 8px 0px #9eb5eb;
}

.purpleBlock {
  background: #e4e9fb;
  width: 136px;
  height: 275px;
  margin-left: auto;
  position: absolute;
  top: -60px;
  right: -60px;
  z-index: -1;
}

.pinkBlock {
  background-color: #f6eff8;
  width: 458px;
  height: 136px;
  position: absolute;
  bottom: -58px;
  z-index: -1;
  left: -58px;
}

.healthCard .card {
  padding-top: 40px;
  padding-bottom: 40px;
}

.scrollerPos {
  top: 50%;
  transform: translateY(-50%);
  left: 30px;
}

/* aman css */

@media (min-width: 1025px) {
  .testimonialSection {
    padding-bottom: 0 !important;
  }
}

@media (max-width: 1599px) {
  .subImg img {
    width: 250px;
  }
  .discoverExpertSection {
    padding-top: 7rem !important;
  }
  .sliderCard .detail {
    right: 0;
  }
}

@media only screen and (max-width: 1399px) {
  .first-banner h1,
  p {
    padding-bottom: 12px;
  }
  .hvrContent p {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
}

@media (max-width: 1366px) {
  .footers .mailInput {
    height: 37px;
  }
}
@media only screen and (max-width: 1199px) {
  .test-box p {
    color: #2d2d2d;
    font-size: 15px;
    line-height: 25px;
    border: #bcbcbb solid 1px;
    padding: 40px 20px;
    border-radius: 10px;
    margin-left: 30px;
  }
  .profile {
    margin-left: 20px;
  }
  .bannerIcon1,
  .bannerIcon2,
  .bannerIcon3,
  .bannerIcon4 {
    opacity: 0.4;
    z-index: -1;
  }
  #root .ant-select-auto-complete .ant-select-selector:not(textarea) {
    height: 40px;
  }
  .subImg img {
    width: 200px;
  }
  .discoverExpertSection {
    padding-top: 3rem !important;
    padding-bottom: 6rem !important;
  }
  .subImg {
    bottom: -15px;
  }
  .sliderCard {
    background-size: 80px;
  }
  .ourPractitionersSection {
    background-size: cover;
    background-position: left 20% center;
    background-image: linear-gradient(
        90deg,
        rgba(219, 205, 240, 0.7) 0%,
        rgba(219, 205, 240, 0.9) 100%
      ),
      url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  }
}
@media only screen and (max-width: 1024px) {
  .ourPractitionersSection {
    min-height: 503px;
  }
  .footers {
    padding-top: 60px;
  }
}
@media only screen and (max-width: 991px) {
  .menu-footer li a {
    font-size: 15px;
  }
  .menu-footer {
    padding-left: 0px;
    margin-left: 0px;
  }
  .creative a {
    margin-bottom: 20px;
  }
  .test-box p {
    color: #2d2d2d;
    font-size: 15px;
    line-height: 23px;
    border: #bcbcbb solid 1px;
    padding: 40px 16px;
    border-radius: 10px;
    margin-left: 50px;
  }
  .profile {
    width: -webkit-max-content;
    width: max-content;
  }
  .profile h4 {
    font-size: 22px;
  }
  .profile span {
    font-size: 15px;
  }
  .subImg {
    margin-top: 35px;
    bottom: 0;
    padding-bottom: 35px;
  }
}
@media only screen and (max-width: 768px) {
  .menu-footer li a {
    font-size: 15px;
  }
  .footer-heading_h2 {
    font-size: 21px;
    line-height: 21px;
  }
  .test-box p {
    color: #2d2d2d;
    font-size: 14px;
    line-height: 20px;
    border: #bcbcbb solid 1px;
    padding: 15px 16px;
    border-radius: 10px;
    margin-left: 80px;
  }
  .profile {
    margin-left: 50px;
  }
  .background-dashboard-card {
    background-image: none;
  }
  .discoverSectionTabs span.active {
    padding: 8px 12px;
  }
  .discoverSectionTabs span {
    font-size: 14px;
  }

  .swiperbtn-wrapper .swiper-button-next::after {
    width: 39px;
    height: 38px;
  }
  .swiperbtn-wrapper .swiper-button-next.swiper-button-disabled::after,
  .swiperbtn-wrapper .swiper-button-prev.swiper-button-disabled::after,
  .swiperbtn-wrapper .swiper-button-prev,
  .swiperbtn-wrapper .swiper-button-next,
  .swiperbtn-wrapper .swiper-button-prev::after {
    width: 38px;
    height: 38px;
  }
  .practitioner__list .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    padding: 14px;
  }
  .hvrContent {
    background: linear-gradient(180deg, rgba(37, 37, 37, 0) 0.36%, rgba(0, 0, 0, 0.8) 87.5%);
    opacity: 1;
    justify-content: end;
    align-items: start;
    text-align: start !important;
    padding: 16px;
  }
  .hvrContent p,
  .hvrContent h5 {
    color: #ffffff !important;
  }
  .hvrContent .nav-link {
    display: none !important;
  }
  .otherSectionCard .cardParent .card span {
    display: none !important;
  }
  .otherSectionCard .cardParent .card {
    height: 320px;
  }
  .otherSectionCard .cardParent .card img {
    height: 100%;
    object-fit: cover;
  }
}
@media only screen and (max-width: 575px) {
  .expertCard .expertImg {
    width: 50px;
    height: 50px;
  }

  .test-box p {
    margin-left: 30px;
  }
  .mainTitle {
    line-height: 1.2;
  }
  .practitioner__list .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    font-size: 18px;
  }
  .practitioner__list
    .ant-collapse
    > .ant-collapse-item.ant-collapse-item-active
    > .ant-collapse-header {
    padding-bottom: 5px;
  }

  .footers .mailInput {
    width: 280px;
  }
  .discoverExpertSection {
    padding-top: 2rem !important;
    padding-bottom: 4.5rem !important;
  }
  .pinkBlock,
  .purpleBlock {
    display: none;
  }
  .healthCard .card {
    padding-top: 30px;
    padding-bottom: 10px;
  }
  .otherSectionCard .card span {
    left: 0;
    transform: translateX(0);
    padding-left: 20px;
  }
  .ourPractitionersSection.faqs-section {
    min-height: 430px;
  }
}

.email-collection-modal .ant-modal-content {
  max-height: 80vh; /* limit height to viewport */
  display: flex;
  flex-direction: column;
  justify-content: center; /* vertically center content inside modal */
  align-items: center; /* horizontally center */
  padding: 20px;
  margin: 0 auto !important;
}

.email-collection-modal .ant-modal-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto; /* scroll if content is tall */
}`, "",{"version":3,"sources":["webpack://./src/assets/css/MainPage.css"],"names":[],"mappings":"AAAA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA,wBAAwB;;AAExB;EACE,iBAAiB;EACjB,mFAAmF;AACrF;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,MAAM;EACN,SAAS;EACT,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,wBAAwB;EACxB,8BAA8B;AAChC;AACA;EACE,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;;;;;;;;;;;;GAYG;AACH,kBAAkB;;AAElB,mBAAmB;AACnB;EACE,oBAAoB;AACtB;AACA,iBAAiB;;AAEjB,kBAAkB;AAClB;;EAEE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;AACtB;AACA,gBAAgB;;AAEhB,gBAAgB;;AAEhB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,0BAAkB;EAAlB,kBAAkB;AACpB;AACA,gBAAgB;AAChB;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA,oBAAoB;;AAEpB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;AACjC;AACA;EACE,aAAa;;EAEb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA,kBAAkB;;AAElB,kBAAkB;;AAElB;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,0BAA0B;EAC1B,gCAAgC;EAChC,gCAAgC;EAChC,2BAA2B;EAC3B,+DAA+D;EAC/D,gFAAgF;EAChF,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;EAClC,0CAA0C;EAC1C,6BAA6B;EAC7B,iCAAiC;EACjC,wBAAwB;AAC1B;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA,iDAAiD;;AAEjD,YAAY;;AAEZ;EACE,YAAY;EACZ,gDAAgD;EAChD,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;;;;;GAMG;;AAEH;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,WAAW;;AAEX;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;;;;;;;;GAUG;AACH;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAAkB;EAAlB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,oBAAoB;;EAEpB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;EACzB,WAAW;;EAEX,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,gDAAgD;EAChD,qEAAqE;AACvE;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,gDAAgD;EAChD,qEAAqE;AACvE;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,UAAU;AACZ;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,qFAAqF;EACrF,YAAY;EACZ,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,wBAAwB;EACxB,2BAA2B;EAC3B,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,aAAa;AACf;AACA;EACE,SAAS;EACT,SAAS;EACT,UAAU;EACV,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,yDAA0E;EAC1E,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,yDAA0E;EAC1E,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,yDAAkE;EAClE,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,yDAAkE;EAClE,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA,mBAAmB;;AAEnB;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,0BAA0B;EAC1B,gCAAgC;EAChC,gCAAgC;EAChC,2BAA2B;EAC3B,+DAA+D;EAC/D,gFAAgF;EAChF,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,gFAAgF;EAChF,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAOA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yFAAyF;AAC3F;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,6FAA6F;EAC7F,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,yDAAsC;EACtC,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,yDAAgD;EAChD,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yDAAgD;EAChD,sBAAsB;EACtB,4BAA4B;EAC5B,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,yDAAiD;EACjD,sBAAsB;EACtB,4BAA4B;EAC5B,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB;yEACuE;EACvE,6BAA6B;EAC7B,wCAAwC;EACxC,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,qDAAqD;AACvD;AACA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,QAAQ;EACR,QAAQ;AACV;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;AACA;EACE,qDAAqD;AACvD;;AAEA;EACE;;;;;;2CAM6C;EAC7C,4BAA4B;EAC5B,wBAAwB;EACxB,iBAAiB;EACjB,qHAAqH;AACvH;;AAEA;EACE;;;;;;2CAMsC;EACtC,4BAA4B;EAC5B,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,0DAA0C;EAC1C,4BAA4B;EAC5B,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,QAAQ;EACR,2BAA2B;EAC3B,UAAU;AACZ;;AAEA,aAAa;;AAEb;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;;IAEE,oBAAoB;EACtB;EACA;IACE,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;;;;IAIE,YAAY;IACZ,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,aAAa;EACf;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;IACtB,oCAAoC;IACpC;;;;;6CAK6C;EAC/C;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,0BAAkB;IAAlB,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,SAAS;IACT,oBAAoB;EACtB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;EACA;;;;;IAKE,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,wFAAwF;IACxF,UAAU;IACV,oBAAoB;IACpB,kBAAkB;IAClB,4BAA4B;IAC5B,aAAa;EACf;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;;;;IAIE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;EACA;IACE,4BAA4B;IAC5B,iCAAiC;EACnC;EACA;;IAEE,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,OAAO;IACP,wBAAwB;IACxB,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB,EAAE,6BAA6B;EAC/C,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,2CAA2C;EACpE,mBAAmB,EAAE,wBAAwB;EAC7C,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB,EAAE,8BAA8B;AAClD","sourcesContent":["html,\nbody {\n  overflow-y: auto;\n}\n\nbody {\n  color: #666666;\n  font-size: 14px;\n  font-family: 'Poppins', sans-serif;\n  font-weight: normal;\n}\n.font-family-poppins {\n  font-family: 'Poppins', sans-serif;\n}\n.search-bar {\n  width: 500px !important;\n  height: 45px;\n  background-color: #eeeeee !important;\n}\n.search-icon {\n  font-size: 35px;\n  color: #666666;\n}\n/* fisrt-banner starts */\n\n.bannerSection {\n  min-height: 40rem;\n  background: linear-gradient(360deg, #cdbbe8 9.1%, rgba(232, 241, 255, 0.47) 89.76%);\n}\n.bannerSection .banner-home {\n  max-width: 790px;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n}\n.mainTitle {\n  line-height: 1.4;\n}\n\n.first-banner h1,\np {\n  padding-bottom: 20px;\n}\n\n.label-bnr {\n  font-size: 18px;\n  font-family: 'Muli', sans-serif;\n  font-weight: 600;\n  margin-bottom: 35px;\n  text-transform: uppercase;\n  color: #1f2b7b;\n  display: inline-block;\n  position: relative;\n  padding-left: 100px;\n  letter-spacing: 0.05em;\n}\n.label-bnr::before {\n  position: absolute;\n  content: '';\n  width: 70px;\n  height: 2px;\n  background: #1f2b7b;\n  top: 0;\n  left: 0px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.slider__headingtext {\n  font-size: 63px;\n  font-weight: bold;\n}\n.slider__content {\n  font-size: 18px;\n  color: #666666;\n}\n.creative {\n  display: inline-block;\n}\n\n/* first banner ends */\nform .col-auto {\n  display: flex !important;\n  justify-content: space-between;\n}\ninput.form-check-input {\n  border: 1px solid black;\n}\n\n/* services starts */\n/* .card-class {\n  margin-top: 30px !important;\n  display: flex;\n  justify-content: center;\n  width: 20rem;\n}\n.card-head {\n  font-size: 45px;\n  color: #2d2d2d;\n  line-height: 50px;\n  font-weight: bold;\n  padding: 0;\n} */\n/* services ends */\n\n/* pricing starts */\n.pricing-title {\n  padding-bottom: 40px;\n}\n/* pricing ends */\n\n/* heading starts*/\n.heading-title h2,\n.heading-title h4 {\n  color: #fff;\n  font-size: 45px;\n  line-height: 50px;\n  font-weight: bold;\n  padding: 0;\n  padding-top: 90px;\n  /* text-align: center; */\n}\n.heading-title_h2 {\n  font-family: Lato, sans-serif;\n  font-size: 45px;\n  font-weight: 700;\n  line-height: 50px;\n  color: #212529 !important;\n}\n.heading-title p {\n  margin: 0px;\n  font-weight: normal;\n  font-size: 17px;\n  line-height: 28px;\n  color: #fff;\n  padding-top: 10px;\n  /* text-align: center; */\n  padding-bottom: 40px;\n}\n/* heading ends*/\n\n/* blog starts */\n\n.latest {\n  background: #fff;\n  padding-top: 10px;\n  padding-left: 0;\n  padding-right: 0;\n  box-shadow: 0 0 69px rgba(13, 3, 3, 0.06);\n  margin-bottom: 55px;\n  width: max-content;\n}\n/* blog starts */\n.blog-col {\n  display: flex;\n  /* justify-content: center; */\n}\n/* customer starts */\n\n.customers {\n  background: #fff;\n  padding-top: 80px;\n  padding-bottom: 50px !important;\n}\n.customer-row {\n  display: flex;\n\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n\n.customer-carousel {\n  position: relative;\n}\n.customer-carousel-item {\n  width: 100%;\n  height: 100%;\n  perspective: 1000px;\n  padding-bottom: 30px;\n}\n.customer-carousel-cap {\n  position: absolute;\n}\n.profile img {\n  border-radius: 50%;\n}\n.test-box p {\n  color: #2d2d2d;\n  font-size: 17px;\n  line-height: 30px;\n  border: #bcbcbb solid 1px;\n  padding: 60px 30px;\n  border-radius: 10px;\n}\n/* customer ends */\n\n/* footer starts */\n\n.customer-col {\n  display: flex;\n  justify-content: center;\n}\n\n.read_more {\n  color: #fff !important;\n  display: inline-block;\n  font-size: 16px !important;\n  text-decoration: none !important;\n  background-size: 200% !important;\n  transition: 0.6s !important;\n  box-shadow: 0px 7px 21px 0px rgba(173, 17, 17, 0.12) !important;\n  background-image: linear-gradient(to left, #caf0ef, #177994, #ee8af8) !important;\n  border-radius: 30px !important;\n  font-weight: bold !important;\n  padding: 10px 30px;\n  /* width: 150px !important; */\n  /* line-height: 61px !important; */\n  /* text-transform: uppercase !important; */\n  text-align: center !important;\n  /* max-width: 230px !important; */\n  /* padding: 10px 20px; */\n}\n.read_more:hover {\n  background-position: right;\n  color: #177994 !important;\n}\n\n/* Extra small devices (phones, 600px and down) */\n\n/* My code */\n\n.card-practitioner {\n  width: 25rem;\n  box-shadow: 0px 7px 21px 0px rgba(0, 0, 0, 0.12);\n  border: none;\n  padding-left: 10px;\n  padding-right: 10px;\n  transition: 0.5s all;\n}\n\n/* .practitioner__list {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n} */\n\n.card__practitioner__text {\n  font-size: 18px;\n  color: #666666;\n}\n\n/* Footer */\n\n.footers {\n  display: block;\n  position: relative;\n  margin-top: 90px;\n  padding-top: 90px;\n  background: #f5f8ff;\n  text-align: center;\n  width: 100%;\n}\n\n/* .footer-heading_h2::before {\n  position: absolute;\n  content: '';\n  width: 15px;\n  height: 15px;\n  background: #fdc001;\n  background: #177994;\n  top: 5px;\n  border-radius: 20px;\n  left: -20px;\n} */\n.footer-heading_h2 {\n  position: relative;\n  /* color: #fff; */\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 23px;\n  text-align: left;\n}\n.menu-footer {\n  text-align: left;\n  margin-bottom: 15px;\n  width: max-content;\n}\n.menu-footer li {\n  margin: 0px;\n  padding: 0px;\n  list-style: none;\n}\n.menu-footer li a {\n  /* color: #979793; */\n\n  line-height: 18px;\n  padding-bottom: 12px;\n  display: block;\n  font-size: 16px;\n}\n.newsL {\n  width: 100%;\n  height: 51px;\n  background: #2d2d2d;\n  color: #c9c7c7;\n  font-size: 17px;\n  font-weight: normal;\n  box-shadow: inherit;\n  padding: 0 15px;\n  border: #fff solid 2px;\n  margin-bottom: 20px;\n  border-radius: 10px;\n}\n\n.subsci_btn {\n  font-size: 16px;\n  transition: ease-in all 0.5s;\n  text-transform: uppercase;\n  color: #fff;\n\n  font-weight: normal;\n  height: 51px;\n  width: 100%;\n  display: block;\n  border-radius: 10px;\n  box-shadow: 0px 7px 21px 0px rgba(0, 0, 0, 0.12);\n  background-image: linear-gradient(to left, #caf0ef, #177994, #ee8af8);\n}\n\n.subsci_btn_blogs {\n  font-size: 16px;\n  transition: ease-in all 0.5s;\n  text-transform: uppercase;\n  color: #fff;\n  font-weight: normal;\n  line-height: 45px;\n  height: 51px;\n  width: 100%;\n  display: block;\n  border-radius: 80px;\n  box-shadow: 0px 7px 21px 0px rgba(0, 0, 0, 0.12);\n  background-image: linear-gradient(to left, #caf0ef, #177994, #ee8af8);\n}\n\n/* copyright section */\n.copyright {\n  padding-top: 50px;\n  padding-bottom: 50px;\n}\n.social-icon {\n  margin: 0px;\n  padding: 0px;\n  list-style: none;\n}\n\n.social-icon li {\n  display: inline-block;\n  margin: 0 2px;\n  padding: 0px;\n  list-style: none;\n  padding-left: 8px;\n  padding-right: 8px;\n  margin-bottom: 16px;\n}\n.social-icon li a {\n  display: flex;\n  gap: 12px;\n}\n.socialIcon {\n  height: 42px;\n  width: 42px;\n}\n.copyright p {\n  /* color: #fff; */\n  font-size: 16px;\n  line-height: 22px;\n  text-align: center;\n  padding-top: 35px;\n  font-weight: normal;\n  margin: 0;\n}\n\n.social_icon_style {\n  font-size: 17px;\n  color: #fff;\n  transition: ease-in all 0.5s;\n  /* background: #2d2d2d; */\n  width: 22px;\n  height: 22px;\n  line-height: 10px;\n  /* border-radius: 50px; */\n  text-align: center;\n  padding-right: 6px;\n}\n.social_icon_style_blogs {\n  font-size: 25px;\n  color: black;\n  transition: ease-in all 0.5s;\n  /* background: #2d2d2d; */\n  width: 45px;\n  height: 45px;\n  line-height: 10px;\n  /* border-radius: 50px; */\n  text-align: center;\n  padding-right: 6px;\n}\n\n.social_icon_style::before {\n  content: '\\f041';\n}\n\n.footers .linkingSection {\n  padding: 50px 0;\n  border-top: 1px solid #d1d1d1;\n  border-bottom: 1px solid #d1d1d1;\n}\n.footers .subScribeSection {\n  margin-bottom: 50px;\n}\n.footers .subScribeSection p {\n  text-transform: capitalize;\n}\n\n.footers .mailInput {\n  border: 0;\n  background: #e4e9fb;\n  border-radius: 25px;\n  height: 48px;\n  padding-left: 24px;\n  max-width: 100%;\n  width: 336px;\n}\n\n.otherSectionCard .card {\n  border: 0;\n  background-color: transparent;\n  z-index: 2;\n}\n.otherSectionCard .card img,\n.otherSectionCard .card {\n  border-radius: 12px;\n}\n.otherSectionCard .card span {\n  position: absolute;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 2;\n  font-weight: bold;\n  width: 100%;\n  text-align: center;\n}\n.otherSectionCard .card::before {\n  content: '';\n  background: linear-gradient(180deg, rgba(37, 37, 37, 0) 30%, rgba(0, 0, 0, 0.6) 100%);\n  height: 100%;\n  width: 100%;\n  z-index: 1;\n  position: absolute;\n  border-radius: 12px;\n}\n\n.otherSectionCard .cardParent:hover .hvrContent {\n  opacity: 0.9;\n}\n.cardParent:hover .card span {\n  opacity: 0;\n}\n.hvrContent {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  z-index: 9;\n  background: #f6eff8;\n  width: calc(100% - 20px);\n  transform: translateX(-50%);\n  height: 100%;\n  border-radius: 12px;\n  padding: 20px 35px;\n  opacity: 0;\n  transition: 0.2s ease-out;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.discoverSectionTabs span.active {\n  border: 1px solid #7578df;\n  padding: 12px 20px;\n  border-radius: 23px;\n  color: #7578df;\n}\n.discoverSectionTabs span:hover {\n  cursor: pointer;\n}\n\n.expertCard .expertImg {\n  width: 80px;\n  height: 80px;\n}\n\n.expertCard hr {\n  border: 0;\n  background-color: #e7e7e7;\n  opacity: 1;\n}\n.expertCard {\n  box-shadow: 0px 0px 8px 0px rgba(105, 145, 210, 0.25);\n  border-radius: 16px;\n  border: 1px solid transparent;\n  transition: 0.4s all;\n}\n.expertCard:hover {\n  border-color: #7578df;\n}\n\n.expertCard .profession {\n  display: -webkit-box;\n  min-height: 61px;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.expertise-main p:last-child {\n  min-height: 91px;\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  padding-bottom: 0;\n  margin-bottom: 20px;\n}\n\n.text-truncate-6 {\n  -webkit-line-clamp: 6;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* slider css start */\n.discoverUsSection .swiperbtn-wrapper {\n  bottom: -80px;\n}\n.swiperbtn-wrapper {\n  top: auto;\n  bottom: 0;\n  right: 50%;\n  transform: translate(50%, -50%);\n  column-gap: 30px;\n}\n.swiperbtn-wrapper .swiper-button-prev,\n.swiperbtn-wrapper .swiper-button-next {\n  width: 49px;\n  height: 48px;\n}\n.swiperbtn-wrapper .swiper-button-prev.swiper-button-disabled::after {\n  content: '';\n  background-image: url('../img/swiper-navigations/swiper-prev-disable.png');\n  background-repeat: no-repeat;\n  background-size: cover;\n  width: 48px;\n  height: 48px;\n}\n.swiperbtn-wrapper .swiper-button-next.swiper-button-disabled::after {\n  content: '';\n  background-image: url('../img/swiper-navigations/swiper-next-disable.png');\n  background-repeat: no-repeat;\n  background-size: cover;\n  width: 48px;\n  height: 48px;\n}\n.swiperbtn-wrapper .swiper-button-prev::after {\n  content: '';\n  background-image: url('../img/swiper-navigations/swiper-prev.png');\n  background-repeat: no-repeat;\n  background-size: cover;\n  width: 48px;\n  height: 48px;\n}\n.swiperbtn-wrapper .swiper-button-next::after {\n  content: '';\n  background-image: url('../img/swiper-navigations/swiper-next.png');\n  background-repeat: no-repeat;\n  background-size: cover;\n  width: 49px;\n  height: 48px;\n}\n.swiper-padding .swiper {\n  padding: 10px 20px;\n}\n/* slider css end */\n\n.joinus .read_mores {\n  margin: 0 auto;\n  display: block;\n  position: relative;\n  z-index: 99;\n  width: 300px !important;\n  color: #fff !important;\n  display: inline-block;\n  font-size: 16px !important;\n  text-decoration: none !important;\n  background-size: 200% !important;\n  transition: 0.6s !important;\n  box-shadow: 0px 7px 21px 0px rgba(173, 17, 17, 0.12) !important;\n  background-image: linear-gradient(to left, #caf0ef, #177994, #ee8af8) !important;\n  border-radius: 30px !important;\n  font-weight: bold !important;\n  text-align: center !important;\n  padding: 15px 20px;\n}\n.joinus .read_more:hover {\n  background-position: right;\n  color: #177994 !important;\n}\n\n.fs--1 {\n  font-size: 12px !important;\n}\n\n.gradent-border {\n  border-radius: 5px !important;\n  border-image-source: linear-gradient(rgba(0, 51, 102, 0.5), rgba(0, 0, 51, 0.5));\n  border-width: 2pt;\n  border-image-slice: 1;\n  --input-bg-color: #fff;\n  border-color: #336cfb !important;\n  box-shadow: none;\n  color: #1f2022;\n  border: 1px solid transparent;\n}\n\n.gradent-text {\n  background: -webkit-linear-gradient(#4389a2, #5c258d);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.gradent-text::-moz-selection {\n  color: #fff !important;\n  background: gray;\n}\n\n.gradent-text::selection {\n  color: #fff !important;\n  background: gray;\n}\n\n.rounded-7 {\n  border-radius: 1.3rem !important;\n}\n\n.card-shadow {\n  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;\n}\n\n.btn-grad:hover {\n  background-position: right center;\n  color: #fff;\n  text-decoration: none;\n}\n\n.btn-grad {\n  background-image: linear-gradient(to right, #5c258d 0%, #4389a2 51%, #5c258d 100%) !important;\n  transition: 0.5s;\n  background-size: 200% auto;\n  box-shadow: 0 0 20px #eee;\n  color: #fff;\n}\n\n.login-btn-grad {\n  background: #5c258d;\n  background-size: 200% auto;\n  color: #fff;\n}\n\n.text-purple {\n  color: #5c258d;\n}\n\n.avatar-2 {\n  width: 60px;\n  height: 60px;\n  object-fit: contain;\n  aspect-ratio: 1;\n}\n\n@media (min-width: 992px) {\n  .no-record {\n    min-height: 320px;\n  }\n\n  .min-h-500 {\n    min-height: 500px;\n  }\n}\n\n.text-gray {\n  color: gray;\n  font-weight: 500;\n}\n\n.scrollbar-thin {\n  scrollbar-width: thin;\n}\n\n.scrollbar-none {\n  scrollbar-width: none;\n}\n\n.life-style-list {\n  list-style-type: disc;\n}\n\nul.life-style-list li {\n  font-size: 16px;\n  font-weight: 500;\n  /* color: #000; */\n  margin-bottom: 5px;\n  text-align: left;\n}\n\nul.life-style-list.small li {\n  font-size: 16px;\n  font-weight: 500;\n  color: #000;\n  margin-bottom: 2px;\n  text-align: left;\n  margin-left: 30px;\n}\n\n.list-image {\n  max-width: 100%;\n  max-height: 260px;\n  width: auto;\n  margin: auto;\n}\n\n.ls-1 {\n  letter-spacing: 1px;\n}\n\n.btn-pink {\n  color: #fff;\n  background-color: #d63484;\n  border-color: #d63484;\n}\n\n.disabled,\n.ant-btn:disabled,\n.btn:disabled {\n  cursor: not-allowed;\n  pointer-events: all !important;\n}\n\n.background-dashboard-card {\n  background-image: url(../img/pana.png);\n  background-size: 275px 140px;\n  background-repeat: no-repeat;\n  background-position-x: right;\n  background-position-y: bottom;\n}\n\n.object-fit-contain {\n  object-fit: contain !important;\n}\n\n.nav-shadow {\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;\n}\n\n.auth-page-btn {\n  max-width: 450px;\n  width: 100%;\n  text-align: left;\n  padding: 10px;\n  color: #1f2022;\n}\n\n.auth-bg-2 {\n  background-image: url('../img/Rectangle 57.png');\n  background-position: 100%;\n  background-size: cover;\n  opacity: 0.8;\n}\n\n.auth-bg-3 {\n  background-image: url('../img/Rectangle 59.png');\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position-x: 0px;\n  opacity: 0.8;\n}\n\n.auth-bg-4 {\n  background-image: url('../img/Rectangle 59.webp');\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position-x: 0px;\n  opacity: 0.8;\n}\n\n.text-black {\n  color: #000 !important;\n}\n\n.bg-white-opacity {\n  background-color: rgba(255, 255, 255, 0.75);\n}\n\n.letter-spacing-1 {\n  letter-spacing: 1px;\n}\n\n#root #search .ant-select-auto-complete .ant-select-selector {\n  border: 1px solid #bd80c2;\n  border-radius: 30px;\n  background-image: linear-gradient(white, white),\n    linear-gradient(to right, rgba(0, 51, 102, 0.5), rgba(0, 0, 51, 0.5));\n  background-origin: border-box;\n  background-clip: content-box, border-box;\n  background-color: #ffffff;\n}\n#root .ant-select-auto-complete .ant-select-selector:not(textarea) {\n  height: 54px;\n  box-shadow: 0px 0px 12px 8px rgba(212, 196, 236, 0.6);\n}\n#root .no-box-shadow > div {\n  height: 40px !important;\n  box-shadow: none !important;\n}\n#root .ant-select-auto-complete {\n  height: 100%;\n  border-radius: 30px !important;\n}\n.anticon.anticon-search svg {\n  color: #bd80c2;\n}\n\n.subImg {\n  margin-top: 15px;\n  position: relative;\n  bottom: -45px;\n}\n.subImg img {\n  border-radius: 12px;\n  box-shadow: 0px 5px 10px 0px rgba(113, 113, 113, 0.25);\n}\n\n.bannerIcon1 {\n  top: 23%;\n  left: 9%;\n}\n\n.bannerIcon2 {\n  top: 43%;\n  left: 15%;\n}\n\n.bannerIcon3 {\n  top: 23%;\n  right: 9%;\n}\n\n.bannerIcon4 {\n  top: 43%;\n  right: 15%;\n}\n\n.discoverExpertSection {\n  padding-top: 10rem !important;\n  padding-bottom: 7.5rem !important;\n}\n.discoverCardSection .card {\n  box-shadow: 0px 0px 8px 0px rgba(105, 145, 210, 0.25);\n}\n\n.ourPractitionersSection {\n  background: linear-gradient(\n      90deg,\n      rgba(242, 198, 222, 0.12) 0%,\n      rgba(219, 205, 240, 0.3) 38.5%,\n      #dbcdf0 55.5%\n    ),\n    url('../img/our-practitioners-section.png');\n  background-repeat: no-repeat;\n  background-size: contain;\n  min-height: 603px;\n  /* background: linear-gradient(90deg, rgba(242, 198, 222, 0.12) 0%, rgba(219, 205, 240, 0.3) 38.5%, #DBCDF0 55.5%); */\n}\n\n.faqs-section {\n  background: linear-gradient(\n      90deg,\n      rgba(242, 198, 222, 0.12) 0%,\n      rgba(219, 205, 240, 0.3) 22.14%,\n      #dbcdf0 43.18%\n    ),\n    url('../img/faqs-setion-bg-img.png');\n  background-repeat: no-repeat;\n  background-size: contain;\n  min-height: 722px;\n}\n\n.quoteImg {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.sliderCard {\n  background-image: url('../img/quotes.svg');\n  background-repeat: no-repeat;\n  background-position: top left;\n  background-size: auto;\n}\n.sliderCard .detail {\n  position: relative;\n  top: -12px;\n  right: -54px;\n  z-index: 1;\n}\n\n.sliderCard .detail img {\n  height: 58px;\n  width: 58px;\n}\n\n.practitioner__list .ant-collapse > .ant-collapse-item > .ant-collapse-header {\n  font-size: 20px;\n  border-radius: 12px !important;\n  padding: 20px;\n  flex-direction: row-reverse;\n  align-items: center;\n}\n\n.practitioner__list.faq_list .ant-collapse > .ant-collapse-item > .ant-collapse-header {\n  padding-left: 0;\n}\n\n.practitioner__list .ant-collapse {\n  background-color: transparent;\n  border: 0;\n}\n\n.ant-collapse-item {\n  margin-bottom: 24px;\n}\n\n.practitioner__list.faq_list .ant-collapse-item {\n  margin-bottom: 0;\n}\n\n.practitioner__list\n  .ant-collapse\n  > .ant-collapse-item.ant-collapse-item-active\n  > .ant-collapse-header {\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.practitioner__list .ant-collapse .ant-collapse-content {\n  border-top: 0;\n  background-color: transparent;\n}\n\n.practitioner__list .ant-collapse .ant-collapse-content > .ant-collapse-content-box {\n  border-bottom-right-radius: 12px !important;\n  border-bottom-left-radius: 12px !important;\n  padding-top: 0;\n}\n\n.practitioner__list.faq_list .ant-collapse .ant-collapse-content > .ant-collapse-content-box {\n  padding-left: 0;\n}\n\n.practitioner__list .ant-collapse > .ant-collapse-item {\n  border-bottom: 0;\n}\n\n.readyGrowImg {\n  z-index: 1;\n}\n\n.readyGrowImg img {\n  border-radius: 12px;\n  box-shadow: 0px 0px 8px 0px #9eb5eb;\n}\n\n.purpleBlock {\n  background: #e4e9fb;\n  width: 136px;\n  height: 275px;\n  margin-left: auto;\n  position: absolute;\n  top: -60px;\n  right: -60px;\n  z-index: -1;\n}\n\n.pinkBlock {\n  background-color: #f6eff8;\n  width: 458px;\n  height: 136px;\n  position: absolute;\n  bottom: -58px;\n  z-index: -1;\n  left: -58px;\n}\n\n.healthCard .card {\n  padding-top: 40px;\n  padding-bottom: 40px;\n}\n\n.scrollerPos {\n  top: 50%;\n  transform: translateY(-50%);\n  left: 30px;\n}\n\n/* aman css */\n\n@media (min-width: 1025px) {\n  .testimonialSection {\n    padding-bottom: 0 !important;\n  }\n}\n\n@media (max-width: 1599px) {\n  .subImg img {\n    width: 250px;\n  }\n  .discoverExpertSection {\n    padding-top: 7rem !important;\n  }\n  .sliderCard .detail {\n    right: 0;\n  }\n}\n\n@media only screen and (max-width: 1399px) {\n  .first-banner h1,\n  p {\n    padding-bottom: 12px;\n  }\n  .hvrContent p {\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 3;\n    overflow: hidden;\n  }\n}\n\n@media (max-width: 1366px) {\n  .footers .mailInput {\n    height: 37px;\n  }\n}\n@media only screen and (max-width: 1199px) {\n  .test-box p {\n    color: #2d2d2d;\n    font-size: 15px;\n    line-height: 25px;\n    border: #bcbcbb solid 1px;\n    padding: 40px 20px;\n    border-radius: 10px;\n    margin-left: 30px;\n  }\n  .profile {\n    margin-left: 20px;\n  }\n  .bannerIcon1,\n  .bannerIcon2,\n  .bannerIcon3,\n  .bannerIcon4 {\n    opacity: 0.4;\n    z-index: -1;\n  }\n  #root .ant-select-auto-complete .ant-select-selector:not(textarea) {\n    height: 40px;\n  }\n  .subImg img {\n    width: 200px;\n  }\n  .discoverExpertSection {\n    padding-top: 3rem !important;\n    padding-bottom: 6rem !important;\n  }\n  .subImg {\n    bottom: -15px;\n  }\n  .sliderCard {\n    background-size: 80px;\n  }\n  .ourPractitionersSection {\n    background-size: cover;\n    background-position: left 20% center;\n    background-image: linear-gradient(\n        90deg,\n        rgba(219, 205, 240, 0.7) 0%,\n        rgba(219, 205, 240, 0.9) 100%\n      ),\n      url('../img/our-practitioners-section.png');\n  }\n}\n@media only screen and (max-width: 1024px) {\n  .ourPractitionersSection {\n    min-height: 503px;\n  }\n  .footers {\n    padding-top: 60px;\n  }\n}\n@media only screen and (max-width: 991px) {\n  .menu-footer li a {\n    font-size: 15px;\n  }\n  .menu-footer {\n    padding-left: 0px;\n    margin-left: 0px;\n  }\n  .creative a {\n    margin-bottom: 20px;\n  }\n  .test-box p {\n    color: #2d2d2d;\n    font-size: 15px;\n    line-height: 23px;\n    border: #bcbcbb solid 1px;\n    padding: 40px 16px;\n    border-radius: 10px;\n    margin-left: 50px;\n  }\n  .profile {\n    width: max-content;\n  }\n  .profile h4 {\n    font-size: 22px;\n  }\n  .profile span {\n    font-size: 15px;\n  }\n  .subImg {\n    margin-top: 35px;\n    bottom: 0;\n    padding-bottom: 35px;\n  }\n}\n@media only screen and (max-width: 768px) {\n  .menu-footer li a {\n    font-size: 15px;\n  }\n  .footer-heading_h2 {\n    font-size: 21px;\n    line-height: 21px;\n  }\n  .test-box p {\n    color: #2d2d2d;\n    font-size: 14px;\n    line-height: 20px;\n    border: #bcbcbb solid 1px;\n    padding: 15px 16px;\n    border-radius: 10px;\n    margin-left: 80px;\n  }\n  .profile {\n    margin-left: 50px;\n  }\n  .background-dashboard-card {\n    background-image: none;\n  }\n  .discoverSectionTabs span.active {\n    padding: 8px 12px;\n  }\n  .discoverSectionTabs span {\n    font-size: 14px;\n  }\n\n  .swiperbtn-wrapper .swiper-button-next::after {\n    width: 39px;\n    height: 38px;\n  }\n  .swiperbtn-wrapper .swiper-button-next.swiper-button-disabled::after,\n  .swiperbtn-wrapper .swiper-button-prev.swiper-button-disabled::after,\n  .swiperbtn-wrapper .swiper-button-prev,\n  .swiperbtn-wrapper .swiper-button-next,\n  .swiperbtn-wrapper .swiper-button-prev::after {\n    width: 38px;\n    height: 38px;\n  }\n  .practitioner__list .ant-collapse > .ant-collapse-item > .ant-collapse-header {\n    padding: 14px;\n  }\n  .hvrContent {\n    background: linear-gradient(180deg, rgba(37, 37, 37, 0) 0.36%, rgba(0, 0, 0, 0.8) 87.5%);\n    opacity: 1;\n    justify-content: end;\n    align-items: start;\n    text-align: start !important;\n    padding: 16px;\n  }\n  .hvrContent p,\n  .hvrContent h5 {\n    color: #ffffff !important;\n  }\n  .hvrContent .nav-link {\n    display: none !important;\n  }\n  .otherSectionCard .cardParent .card span {\n    display: none !important;\n  }\n  .otherSectionCard .cardParent .card {\n    height: 320px;\n  }\n  .otherSectionCard .cardParent .card img {\n    height: 100%;\n    object-fit: cover;\n  }\n}\n@media only screen and (max-width: 575px) {\n  .expertCard .expertImg {\n    width: 50px;\n    height: 50px;\n  }\n\n  .test-box p {\n    margin-left: 30px;\n  }\n  .mainTitle {\n    line-height: 1.2;\n  }\n  .practitioner__list .ant-collapse > .ant-collapse-item > .ant-collapse-header {\n    font-size: 18px;\n  }\n  .practitioner__list\n    .ant-collapse\n    > .ant-collapse-item.ant-collapse-item-active\n    > .ant-collapse-header {\n    padding-bottom: 5px;\n  }\n\n  .footers .mailInput {\n    width: 280px;\n  }\n  .discoverExpertSection {\n    padding-top: 2rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .pinkBlock,\n  .purpleBlock {\n    display: none;\n  }\n  .healthCard .card {\n    padding-top: 30px;\n    padding-bottom: 10px;\n  }\n  .otherSectionCard .card span {\n    left: 0;\n    transform: translateX(0);\n    padding-left: 20px;\n  }\n  .ourPractitionersSection.faqs-section {\n    min-height: 430px;\n  }\n}\n\n.email-collection-modal .ant-modal-content {\n  max-height: 80vh; /* limit height to viewport */\n  display: flex;\n  flex-direction: column;\n  justify-content: center; /* vertically center content inside modal */\n  align-items: center; /* horizontally center */\n  padding: 20px;\n  margin: 0 auto !important;\n}\n\n.email-collection-modal .ant-modal-body {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow-y: auto; /* scroll if content is tall */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
